export default __webpack_public_path__ + "static/media/banner_824.c8f996a9.jpg";